<template>
  <motlet-neo :options="motletOptions">
    <template v-slot:content="{ props }">
      <line-chart :settings="settings" :motlet="props.motlet" :store-name="storeName" :active-increment="activeIncrement" />
    </template>
  </motlet-neo>
</template>

<script>
import { merge } from 'lodash';
// BEGIN::Added.by.KWShin.2024.03.11.
import bus from '@/utils/bus';
// FINISH::Added.by.KWShin.2024.03.11.
// BEGIN::Added.by.SHJ.2026.04.27.
import { api } from '@/api/common/instances';
// FINISH::Added.by.SHJ.2026.04.27.
import lineChartable from './lineChartable';

export default {
  mixins: [lineChartable],
  data() {
    return {
      motletOptions: {
        id: 'dv/abap/os/mem',
        title: 'dv.title.mem',
        monitor: { monitorCode: 'C_PCAP_OS_MEM', eventCode: 'ABAP_OS_MEM', points: 60 },
        settings: {
          chart: {
            use: true,
            field: {},
          },
        },
        xAxisPoints: {
          use: true,
          divider: true,
          ready: false,
          value: 60,
          default: 60,
        },
      },
      // Realtime 데이터 가공을 위한 임시 버퍼들.
      socketData: [],
      socketFlag: [],
    };
  },
  watch: {
    sstmId: {
      handler() {
        // BEGIN::Modified.by.KWShin.2024.03.11.
        // this.sendMessage();
        if (this.activeIncrement && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.03.11.
      },
    },
    activeIncrement: {
      immediate: true,
      handler(value) {
        // BEGIN::Modified.by.KWShin.2024.03.11.
        // if (value) this.sendMessage();
        if (value && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.03.11.
      },
    },
    // BEGIN::Added.by.SHJ.2026.05.13. 언어 변경 시 헤더 타이틀 재합성
    '$i18n.locale'() {
      const field = this.motletOptions.settings.chart.field;
      if (field && field.code) this.chartFieldChanged(field.code);
    },
    // FINISH::Added.by.SHJ.2026.05.13.
  },
  methods: {
    /**
     * Modified.by.KWShin.2024.03.11
     * 수정사항에 대한 Comment는 PcapCpu.vue의 동일부분을 참조할 것.2024.03.11.KWShin.
     */
    /*
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const bound = response.length < this.monitor.points ? response.length : this.monitor.points;
      const data = response.slice(response.length - bound).map(item => {
        const {
          data: [data],
        } = item;
        return this.dataHandler({ ctime: item.ctime, ...data });
      });
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        this.prepend(['memUsedRate', 'swapUsedRate']);
      }
    },
    */
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const data = response.map(item => {
        const {
          data: [data],
        } = item;
        return this.dataHandler({ ctime: item.ctime, ...data });
      });
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        this.socketFlag = this.descendants.map(des => {
          return { id: des.id, arrived: false };
        });
        this.prepend(['memUsedRate', 'swapUsedRate']);
        // 데이터 수집이 안되고 있는 시스템이 있을 수 있으므로 this.data의 유무를 체크해야 한다.
        if (this.data && this.data.length > 0) {
          bus.$emit(`change:timestamp-${this.storeName}`, {
            eventCode: this.motletOptions.monitor.eventCode,
            timestamp: this.data[this.data.length - 1].ctime,
          });
        }
        // BEGIN::Added.by.SHJ.2026.04.27.
        // WS 버퍼가 차트 X축 개수(monitor.points)만큼 채우지 못한 경우 앞쪽 빈 구간을 DB에서 보충한다.
        this.backfillFromDb();
        // FINISH::Added.by.SHJ.2026.04.27.
      }
    },
    wsDataHandler(key, response, ctime) {
      const [data] = response;
      const socketData = this.dataHandler({ ctime: parseInt(ctime), ...data });
      const target = this.data.find(d => d.id == key.instId);
      if (target) {
        target.data.push(socketData);
        // this.prepop();
        target.data.splice(0, 1);
      }
      // BEGIN::Added.by.KWShin.2024.03.11.
      const inst = this.socketFlag.find(i => i.id == key.instId);
      if (inst.arrived) {
        this.socketFlag.forEach(i => {
          if (i.arrived == false) {
            const target = this.data.find(d => d.id == i.id);
            if (target) {
              target.data.push({ ctime: parseInt(ctime), stime: parseInt(ctime), memUsedRate: undefined, swapUsedRate: undefined });
              // this.prepop();
              target.data.splice(0, 1);
            }
          }
          if (i.id == key.instId) i.arrived = true;
          else i.arrived = false;
        });
      } else {
        inst.arrived = true;
      }
      // FINISH::Added.by.KWShin.2024.03.11.
    },
    dataHandler(data) {
      const ctime = parseInt(data.ctime);
      return {
        ctime: ctime - (ctime % this.monitor.cycle), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정,
        stime: parseInt(data.stime),
        // BEGIN::Modified.by.KWShin.2024.03.011
        // memUsedRate: Math.ceil((parseInt(data.memUsed) / parseInt(data.memTotal)) * 100),
        // swapUsedRate: Math.ceil((parseInt(data.swapUsed) / parseInt(data.swapToal)) * 100),
        memUsedRate: data.memTotal ? Math.ceil((parseInt(data.memUsed) / parseInt(data.memTotal)) * 100) : 0,
        swapUsedRate: data.swapSize ? Math.ceil((parseInt(data.swapSize - data.swapFree) / parseInt(data.swapSize)) * 100) : 0,
        // BEGIN::Modified.by.KWShin.2024.03.011
      };
    },
    // BEGIN::Added.by.SHJ.2026.04.27.
    /**
     * WS 버퍼가 monitor.points 만큼 채워지지 않았을 때 DB에서 부족한 앞 구간을 조회해
     * 이미 비어있는 슬롯(memUsedRate===undefined)에만 값을 주입한다. 실제 WS 데이터는 덮어쓰지 않는다.
     */
    async backfillFromDb() {
      if (!this.data || this.data.length === 0) return;
      const firstInst = this.data[0].data;
      if (!firstInst || firstInst.length === 0) return;
      const realPoints = firstInst.filter(d => d.memUsedRate !== undefined && d.memUsedRate !== '');
      if (realPoints.length === firstInst.length) return;
      const beginYmdhms = firstInst[0].ctime;
      const endYmdhms = realPoints.length > 0 ? realPoints[0].ctime - this.monitor.cycle : firstInst[firstInst.length - 1].ctime;
      if (endYmdhms < beginYmdhms) return;
      const params = {
        beginYmdhms,
        endYmdhms,
        sstmId: this.sstmId,
        motletCode: this.monitor.monitorCode,
        ...this.dataParam,
      };
      try {
        const { data: results } = await api.get('/motlet-data/chart', { params });
        if (!results || results.length === 0) return;
        results.forEach(result => {
          const inst = this.data.find(d => d.id === result.key.instId);
          if (!inst) return;
          result.data.forEach(db => {
            const dbCtime = parseInt(db.ctime);
            const slot = inst.data.find(p => p.ctime === dbCtime);
            if (slot && (slot.memUsedRate === undefined || slot.memUsedRate === '')) {
              slot.memUsedRate = parseInt(db.memUsedRate);
              slot.swapUsedRate = parseInt(db.swapUsedRate);
              if (db.stime) slot.stime = parseInt(db.stime);
            }
          });
        });
      } catch (e) {
        // DB 조회 실패 시 차트는 WS 실시간 수신으로 점진적으로 채워지므로 무시한다.
        console.warn('[PcapMemory] backfillFromDb failed', e);
      }
    },
    // FINISH::Added.by.SHJ.2026.04.27.
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.descendants.map(descendant => ({
          key: { name: 'pcapOsMem', sstmId: descendant.systemId, instId: descendant.id },
          fields: ['stime', 'memTotal', 'memUsed', 'swapTotal', 'swapUsed'],
          // BEGIN::Added.by.KWShin.2024.03.11.
          bufferSize: this.monitor.points,
          // FINISH::Added.by.KWShin.2024.03.11.
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    /**
     * Added.by.KWShin.20204.03.07.
     * 부모가 X축 길이 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 X축 길이 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    xPointsChanged(xPoints) {
      this.motletOptions.xAxisPoints.ready = true;
      this.motletOptions.xAxisPoints.value = xPoints;
      this.motletOptions.monitor.points = xPoints;
      // setXAxisPoints()는 lineChartable.js에 mixins된 motletable.js에 선언된 메소드로 store를 변경시켜준다.
      this.setXAxisPoints(xPoints);
      this.setMonitor(this.motletOptions.monitor);
      /*
       * DB 설정에서 읽어온 xPoints 값을 부모가 전달해주기 전까지는 데이터 구독이 방지되어 있는 상태이므로,
       * 부모에게서 통지가 왔을 때 데이터 구독을 시작한다.
       */
      if (this.activeIncrement) this.sendMessage();
    },
    /**
     * Added.by.KWShin.20204.03.11.
     * 부모가 차트 필드 항목 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 차트 필드 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    chartFieldChanged(code) {
      this.motletOptions.settings.chart.field = this.chartFields.find(f => f.code == code);
      // setChartField()는 lineChartable.js에 mixins된 motletable.js에 선언된 메소드로 store를 변경시켜준다.
      // 설정값은 API로 DB를 갔다오므로 지연이 발생하고
      // store는 MotletNeo.vue가 생성되는 시점에 등록되므로
      // 부모가 설정 변경을 알려줄 때 다시 한번 store 값을 변경해준다.
      this.setChartField(code);
      // 차트 항목이 변경되었으므로 서브타이틀을 바꾸어 준다.2026.06.16.
      this.motletOptions.subTitle = `(${this.motletOptions.settings.chart.field.text})`;
    },
  },
  created() {
    // BEGIN::Added.by.KWShin.2024.03.11.
    bus.$on(`update:xAxisPoints-${this.motletOptions.id}`, xAxisPoints => {
      bus.$emit(`update:activeIncrement`, false);
      this.xPointsChanged(xAxisPoints);
    });
    bus.$on(`update:chartFieldCode-${this.motletOptions.id}`, chartFieldCode => {
      this.chartFieldChanged(chartFieldCode);
    });
    // FINISH::Added.by.KWShin.2024.03.11.
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2024.03.11.
    bus.$off(`update:xAxisPoints-${this.motletOptions.id}`);
    bus.$off(`update:chartFieldCode-${this.motletOptions.id}`);
    // FINISH::Added.by.KWShin.2024.03.11.
  },
};
</script>
